import { GRAPH_URL } from "../../../constants";

const query = `
mutation PublicLogin($type: LoginType!, $credentials: LoginCredentials!, $email: String, $deviceInfo: JSON, $country: Country) {
    login(type: $type, credentials: $credentials, email: $email, deviceInfo: $deviceInfo, country: $country) {
      id
      token
      deviceInfo
      sources {
        name
      }
    }
  }
`;

const submitTopnine = variables =>
  fetch(GRAPH_URL, {
    method: "POST",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ query, variables })
  })
    .then(res => res.json())
    .then(res => {
      if (res.errors) {
        const message = res.errors[0].message;
        const error = new Error(
          message.includes("private")
            ? "Public accounts only. Download the app for private account!"
            : message
        );
        error.name = res.errors[0].name;
        throw error;
      }
      return res;
    });

export default submitTopnine;
